export const OPEN_TABLE_CELL_VALUE = 'trevor-table:open-cell-value';
export const TABLE_DRILL_DOWN = 'trevor-table:drill-down';
export const SCROLL = 'trevor-scroll:scroll';
export const ERASE_PIN = 'trevor-pin:erase';
export const SIDEBAR_ANIMATION_FINISHED = 'trevor-sidebar:animation-finished';
export const DASHBOARD_PREVIEW_WIDGET_CREATED =
  'trevor-dashboard:preview-widget-created';
export const NEW_SAVED_QUERY_SAVED =
  'trevor-saved-query:save-as-new-is-successful';
export const OPEN_SHARE_WITH_TEAM_MODAL = 'trevor-modal:share-with-team';
export const OPEN_GOOGLE_SHEETS_EXPORT_MODAL =
  'trevor-modal:google-sheets-export';
export const OPEN_SLACK_NOTIFICATION_MODAL = 'trevor-modal:slack-notification';
export const OPEN_EMAIL_ALERT_MODAL = 'trevor-modal:email-alert';
